import Api from './ApiService'

export default {
    get(keyword, pageNumber, sort) {
        return Api().get(`aulas/adm?keyword=${keyword}&pageNumber=${pageNumber}&sort=${sort}`);
    },
    getOne(id) {
        return Api().get(`aulas/${id}`);
    },
    create(data) {
        return Api().post(`aulas`, data);
    },
    update(data) {
        return Api().put(`aulas/${data.id}`, data);
    }
}